import moment from 'moment';
import momentHijri from 'moment-hijri';

import { Pipe, PipeTransform } from '@angular/core';

import { IDate } from '../models/models';
import { MomentTransformType } from '../models/enums';

@Pipe({ name: 'moment' })
export class MomentPipe implements PipeTransform {
    moment = moment;
    momentHijri = momentHijri;

    defaultHijriDateFormat = 'iYYYY/iM/iD'
    defaultGregorianDateFormat = 'YYYY/MM/DD'

    transform(value: any, momentTransformType: MomentTransformType, inputFormat?: string, outputFormat?: string) {

        this.moment.locale('en-US')
        this.momentHijri.locale('en-US')
        //
        switch (momentTransformType) {
            case MomentTransformType.ToGregorianIsoStringFormat: {
                return this.getGregorianIsoFormat(value, false, inputFormat, outputFormat)
                break;
            }
            case MomentTransformType.ToGregorianIsoStringFormatFromHijri: {
                return this.getGregorianIsoFormat(value, true, inputFormat, outputFormat)
                break;
            }
            case MomentTransformType.ToGregorianUtcIsoStringFormat: {
                return this.getGregorianUtcIsoFormat(value, false, inputFormat, outputFormat)
                break;
            }
            case MomentTransformType.ToGregorianUtcIsoStringFormatFromHijri: {
                return this.getGregorianUtcIsoFormat(value, true, inputFormat, outputFormat)
                break;
            }
            case MomentTransformType.ToGregorianCalendarUtcDateObjectFromIsoString: {
                return this.getCalendarDateObjectFromIsoString(value, false)
                break;
            }



            case MomentTransformType.ToHijriIsoStringFormat: {
                return this.getHijriIsoFormat(value, true, inputFormat, outputFormat)
                break;
            }

            //TODO
            // case MomentTransformType.ToGregorianIsoStringFormatFromHijri:{
            //     return this.getGregorianIsoFormat(value, true, inputFormat, outputFormat)
            //     break;
            // }
            // case MomentTransformType.ToGregorianUtcIsoStringFormat:{
            //     return this.getGregorianUtcIsoFormat(value, false, inputFormat, outputFormat)
            //     break;
            // }
            // case MomentTransformType.ToGregorianUtcIsoStringFormatFromHijri:{
            //     return this.getGregorianUtcIsoFormat(value, true, inputFormat, outputFormat)
            //     break;
            // }
            // case MomentTransformType.ToGregorianCalendarUtcDateObjectFromIsoString:{
            //     return this.getCalendarDateObjectFromIsoString(value, false)
            //     break;
            // }




            case MomentTransformType.ToGregorianCalendarDateObjectFromIsoString: {
                return this.getCalendarDateObjectFromIsoString(value, false)
                break;
            }
            case MomentTransformType.ToHijriCalendarUtcDateObjectFromIsoString: {
                return this.getCalendarUtcDateObjectFromIsoString(value, true)
                break;
            }
            case MomentTransformType.ToHijriCalendarDateObjectFromIsoString: {
                return this.getCalendarDateObjectFromIsoString(value, true)
                break;
            }
            default:
                return null;
        }
    }

    getGregorianIsoFormat(date: string, isHijri?: boolean, inputFormat?: string, outputFormat?: string): string {

        let isoDate = '';
        let momentGergorianDate;
        if (isHijri) {
            let momentHijriDate = this.momentHijri(date, inputFormat ? inputFormat : this.defaultHijriDateFormat);
            let formattedGergorianDate = momentHijriDate.format(this.defaultGregorianDateFormat);
            momentGergorianDate = this.moment(formattedGergorianDate, this.defaultGregorianDateFormat);
        }
        else {
            momentGergorianDate = this.moment(date, inputFormat ? inputFormat : this.defaultGregorianDateFormat);
        }
        isoDate = outputFormat ? momentGergorianDate.format(outputFormat) : momentGergorianDate.format('YYYY-MM-DDThh:mm:ss');

        return isoDate;
    }

    getGregorianUtcIsoFormat(date: string, isHijri?: boolean, inputFormat?: string, outputFormat?: string): string {
        let isoDate = '';
        let momentGergorianDate;
        if (isHijri) {
            let momentHijriDate = this.momentHijri.utc(date, inputFormat ? inputFormat : this.defaultHijriDateFormat);
            let formattedGergorianDate = momentHijriDate.format(this.defaultGregorianDateFormat);
            momentGergorianDate = this.moment.utc(formattedGergorianDate, this.defaultGregorianDateFormat);
        }
        else {
            momentGergorianDate = this.moment.utc(date, inputFormat ? inputFormat : this.defaultGregorianDateFormat);
        }
        isoDate = outputFormat ? momentGergorianDate.format(outputFormat) : momentGergorianDate.format('YYYY-MM-DDThh:mm:ss');
        return isoDate;
    }

    getHijriIsoFormat(date: string, isHijri?: boolean, inputFormat?: string, outputFormat?: string): string {
        let isoDate = '';
        let momentHijriDate: any;
        if (isHijri) {
            momentHijriDate = this.momentHijri(date, inputFormat ? inputFormat : this.defaultHijriDateFormat);

        }
        //TODO
        // else {
        //     momentHijriDate = this.moment(date, inputFormat ? inputFormat : this.defaultGregorianDateFormat);
        // }
        isoDate = outputFormat ? momentHijriDate.format(outputFormat) : momentHijriDate.format('YYYY-MM-DDThh:mm:ss');

        return isoDate;
    }


    getCalendarUtcDateObjectFromIsoString(isoDate: string, isHijri?: boolean): IDate {
        let year = (isHijri) ? this.momentHijri.utc(isoDate).iYear() : this.moment.utc(isoDate).year();
        let month = (isHijri) ? this.momentHijri.utc(isoDate).iMonth() + 1 : this.moment.utc(isoDate).month() + 1;
        let day = (isHijri) ? this.momentHijri.utc(isoDate).iDate() : this.moment.utc(isoDate).date();
        let dateModel: IDate = {
            year: year.toString(),
            month: month.toString(),
            day: day.toString()
        }
        return dateModel;
    }

    getCalendarDateObjectFromIsoString(isoDate: string, isHijri?: boolean): IDate {
        let year = (isHijri) ? this.momentHijri(isoDate).iYear() : this.moment(isoDate).year();
        let month = (isHijri) ? this.momentHijri(isoDate).iMonth() + 1 : this.moment(isoDate).month() + 1;
        let day = (isHijri) ? this.momentHijri(isoDate).iDate() : this.moment(isoDate).date();
        let dateModel: IDate = {
            year: year.toString(),
            month: month.toString(),
            day: day.toString()
        }
        return dateModel;
    }

}